import { render, staticRenderFns } from "./EditTextColor.vue?vue&type=template&id=023ef284&"
import script from "./EditTextColor.vue?vue&type=script&lang=js&"
export * from "./EditTextColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports